export default __webpack_public_path__ + "fonts/inter-latin-700-normal.90e1ac1b0ff515438bda.woff";